module.exports = __webpack_public_path__ + "static/img/viral_25.6d991dcc.jpg";